module.exports = __webpack_public_path__ + "static/media/tie-rods.80a72742.svg";